import gql from 'graphql-tag';

export const SEND_RENEW_NOTIFICATIONS = gql`
  mutation {
    sendRenewNotifications
  }
`;
